import { Injectable } from "@angular/core";
import { WizardStep } from "../../model/wizard-step";
const Shepherd = require('shepherd.js');
import { WizardIdEnum } from "@app/core/model/enum/wizard-id.enum";
import { Subject } from "rxjs";

@Injectable()
export abstract class WizardAbstractService {
    private steps: WizardStep[] = [];
    protected idWizard: WizardIdEnum;
    private tour: any;
    protected initRoute: string;
    protected label: string;
    protected description: string;
    public onWizardEnd$ = new Subject<void>();
    protected tourConfig = {
        useModalOverlay: true,
        defaultStepOptions: {
            scrollTo: { behavior: 'smooth', block: 'center' },
            cancelIcon: { enabled: true, label: 'Fermer' },
            classes: 'shepherd-theme-custom',
            modalOverlayOpeningPadding: 8,
            modalOverlayOpeningRadius: 4
        }
    };


    protected addStep(step: WizardStep): void {
        this.steps.push(step);
    }

    getInitRoute(): string {
        return this.initRoute;
    }

    getLabel(): string {
        return this.label;
    }

    getDescription(): string {
        return this.description;
    }

    /**
     * Détermine si le wizard est disponible pour l'utilisateur dans le contexte courant.
     * Peut être surchargé par les services de wizard spécifiques.
     */
    isAvailable(): boolean {
        return true;
    }

    /**
    * Initialise et démarre le wizard
    */
    start(): void {
        if (this.steps.length === 0) {
            console.warn('No steps defined for wizard');
            return;
        }

        const ShepherdClass = (Shepherd as any).default || Shepherd;
        this.tour = new ShepherdClass.Tour(this.tourConfig);
        // Ajouter tous les steps au tour
        this.steps.forEach(step => {
            this.tour.addStep(step.toShepherdStep());
        });
        
        this.tour.on('complete', () => {
            console.log(' Wizard completed');
            this.onWizardEnd$.next();
        });

        this.tour.on('cancel', () => {
            console.log(' Wizard cancelled');
            this.onWizardEnd$.next();
        });
        this.tour.start();
    }


    /**
     * Annule le wizard
     */
    cancel(): void {
        if (this.tour) {
            this.tour.cancel();
        }
    }

    /**
        * Complète le wizard
        */
    complete(): void {
        if (this.tour) {
            this.tour.complete();
        }
    }

    /**
     * Passe à l'étape suivante
     */
    next(): void {
        if (this.tour) {
            this.tour.next();
        }
    }

    /**
     * Retourne à l'étape précédente
     */
    back(): void {
        if (this.tour) {
            this.tour.back();
        }
    }

    /**
         * Vérifie si le wizard est actif
         */
    isActive(): boolean {
        return this.tour?.isActive() || false;
    }

    // /**
    //  * Vérifie si l'utilisateur a déjà vu ce wizard
    //  */
    // hasBeenSeen(): boolean {
    // }

    // /**
    //  * Réinitialise le flag "déjà vu"
    //  */
    // resetSeenFlag(): void {
    // }
}